import { win } from '@rei/browser-shim';
import ServerProp from '@rei/server-prop';

// TODO
// remove this package in favor of window.metrics included with crampon 4

/**
 * Tracking component for interaction with window.metrics library
 * @type {Object}
 */
const Tracking = {
  /**
   * Default page configuration incase data does not exist in DOM
   * @type {Object}
   */
  pageConfig: {
    siteId: 'opo',
    templateType: 'outdoor school',
    contentType: 'non-commerce',
    subSection1: 'outdoor school',
    pageName: '',
  },

  /**
   * Page meta data key for accessing analytics data
   * @type {String}
   */
  PAGE_META_DATA_KEY: 'page-meta-data',

  /**
   * Data attribute used for binding click event to DOM elements
   * @type {String}
   */
  DATA_ATTR: 'data-analytics-obj',

  /**
   * Build page config data
   * @param  {Object} options Optional settings for page configuration
   */
  buildPageConfig(options) {
    const mergedPageConfig = {};
    const pageMetaData = new ServerProp(this.PAGE_META_DATA_KEY).get();
    Object.assign(mergedPageConfig, this.pageConfig, options, pageMetaData);
    // add pageName if it is passed via options, merge with siteId
    if (pageMetaData && !pageMetaData.pageName && options && options.pageName) {
      mergedPageConfig.pageName = `${this.pageConfig.siteId}:${options.pageName}`;
    }
    // update page config based on options passed in and DOM object
    Object.assign(this.pageConfig, mergedPageConfig);
  },

  /**
   * Get the current page configuration
   * @return {Object} Page configuration option
   */
  getPageConfig() {
    if (!this.pageConfig.pageName || this.pageConfig.pageName === '') {
      this.buildPageConfig();
    }
    return this.pageConfig;
  },

  /**
   * Register page view with metrics lib
   * @param  {Object} options Metrics page view data
   */
  view(options) {
    const pageParams = { ...this.pageConfig, ...options };
    try {
      win.metrics.view(pageParams);
    } catch (e) {
      // Error in view tracking
    }
  },

  /**
   * Track clicks within metric lib
   * @param  {Object} options Link options to pass to metrics
   * @param  {Object} event   Event object from click
   */
  link(options, event) {
    if (!options) {
      // Error in link tracking: no options provided
      return;
    }
    try {
      win.metrics.click(options, event);
    } catch (e) {
      // Error in link tracking
    }
  },

  /**
   * Generate link data based based on elements data attribute
   * @param  {Object} elem DOM element to track on click
   * @return {Object}      Analytics data to trigger event with
   */
  generateLinkTrackName(elem) {
    if (!elem) {
      // Error in link tracking: no elem provided
      return false;
    }
    if (!this.pageConfig.pageName || this.pageConfig.pageName === '') {
      this.buildPageConfig();
    }
    const { pageName } = this.pageConfig;
    const analyticsData = elem.dataset.analyticsObj || elem.textContent.replace(/\s+/g, ' ').trim();
    try {
      const analyticsJSON = JSON.parse(analyticsData.replace('&quot;', '"'));
      // append page name to linkName in object
      if (analyticsJSON.linkName) {
        analyticsJSON.linkName = `${pageName}_${analyticsJSON.linkName}`;
      }
      return analyticsJSON;
    } catch (e) {
      return { linkName: `${pageName}_${analyticsData}` };
    }
  },

  /**
   * Handle click on DOM elements with data-analytics attribute present
   * @param  {Object} e Click handler event object
   */
  clickHandler(e) {
    this.link(this.generateLinkTrackName(e.currentTarget), e);
  },

  /**
   * Update click handlers on DOM elements with data-analytics attribute present
   */
  updateHandlers() {
    document.querySelectorAll(`[${this.DATA_ATTR}]`).forEach((el) => {
      if (!el.tracking) {
        el.addEventListener('click', this.clickHandler.bind(this));
      }
      Object.assign(el, { tracking: true });
    });
  },

  /**
   * Init tracking with metrics lib
   * @param  {Object} options Page config tracking options
   */
  init(options) {
    this.buildPageConfig(options);
    if (this.pageConfig.pageName === '') {
      // Error in metrics init: no pageName configured
      return;
    }
    this.updateHandlers();
  },
};

export default Tracking;
